import * as Sentry from '@sentry/react';

export interface Logger {
  debug: (...args: unknown[]) => void;
  info: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  error: (...args: unknown[]) => void;
}

function toBreadcrumbMessage(arg: unknown): string {
  if (typeof arg === 'string') return arg;
  if (arg instanceof Error) return arg.message;
  try {
    return JSON.stringify(arg);
  } catch {
    return String(arg);
  }
}

function addBreadcrumb(module: string, level: 'debug' | 'info' | 'warning' | 'error', args: unknown[]): void {
  Sentry.addBreadcrumb({
    category: module,
    level,
    message: args.map(toBreadcrumbMessage).join(' '),
    timestamp: Date.now() / 1000
  });
}

export function createLogger(module: string): Logger {
  const isDev = import.meta.env.DEV;

  return {
    debug: (...args: unknown[]) => {
      addBreadcrumb(module, 'debug', args);
      if (isDev) {
        console.debug(`[${module}]`, ...args);
      }
    },
    info: (...args: unknown[]) => {
      addBreadcrumb(module, 'info', args);
      if (isDev) {
        console.info(`[${module}]`, ...args);
      }
    },
    warn: (...args: unknown[]) => {
      addBreadcrumb(module, 'warning', args);
      console.warn(`[${module}]`, ...args);
    },
    error: (...args: unknown[]) => {
      addBreadcrumb(module, 'error', args);
      console.error(`[${module}]`, ...args);
    }
  };
}
